module.exports = __webpack_public_path__ + "img/top7.719ad4b3.png";